import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../App.css";
import Success from "../assets/images/successful.png";

const SignUpSuccessfully = () => {
    return (
        <div className="LoginArea" >
            <div className="LoginBox">
              <div className="SuccessPassword">
              <figure>
                    <img src={Success} />
                </figure>
                <p className="Successfull">Congratulations! Your account has been created successfully!</p>
                <p className="Successfull">You can login once admin approve your account</p>
                <Link className="Button" to="/">Let's Explore</Link>
              </div>
            </div>
        </div>
    );
}
export default SignUpSuccessfully